module.exports = new __parcel__URL__("ecco-surface-height-change--dataset-cover.eddd714b.jpg").toString();